import { cacheKeys } from "@constants/cache-keys";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useQuery } from "@tanstack/react-query";
import { getMixedItemDistribution } from "api/queries";
import type { MixedItemDistAction } from "./types";
import useClerkUser from "./useClerkUser";
const useMixedItemDist = (enabled = true, action?: MixedItemDistAction) => {
	const {
		currentExamContext: { examId, studyPackCollectionId },
	} = useExamContext();
	const { userLogicalId } = useClerkUser();

	const finalAction = action || "COMMON_DISTRIBUTION";

	const result = useQuery({
		queryKey: [
			cacheKeys.home,
			userLogicalId,
			finalAction,
			studyPackCollectionId,
		],
		queryFn: async () =>
			await getMixedItemDistribution({
				action: finalAction,
				examId: examId!,
				collectionId: studyPackCollectionId!,
			}),
		enabled: !!userLogicalId && enabled && !!examId,
	});
	return {
		...result,
		data: result.data,
	};
};

export default useMixedItemDist;
